import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

export interface LayerData {
  opacity: number;
}

export interface LayerOpacityState {
  layers: Record<string, LayerData>;
  // we don't want more than one layer controls to be opened at a time
  openedLayerControlsId: string | null;
}

const initialState: LayerOpacityState = {
  layers: {},
  openedLayerControlsId: null,
};

const layerOpacitySlice = createSlice({
  name: 'layerOpacity',
  initialState,
  reducers: {
    setLayerState: (
      state,
      {
        payload,
      }: PayloadAction<{
        layerId: string;
        layerData: LayerData;
      }>,
    ) => {
      state.layers[payload.layerId] = payload.layerData;
    },
    setOpenedLayerControlsId: (
      state,
      { payload }: PayloadAction<string | null>,
    ) => {
      state.openedLayerControlsId = payload;
    },
    clearOpenedLayerControlsId: state => {
      state.openedLayerControlsId = null;
    },
  },
});

export const {
  setLayerState,
  setOpenedLayerControlsId,
  clearOpenedLayerControlsId,
} = layerOpacitySlice.actions;

const persistConfig = {
  key: 'layerOpacity',
  blacklist: ['openedLayerControlsId'],
  storage,
};

export default persistReducer(persistConfig, layerOpacitySlice.reducer);
